<template>
    <header
        ref="header"
    >
        <div id="main-menu" class="sticker">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-2 hidden-sm hidden-xs">
                        <div class="logo">
                            <a href="/">
                                <img 
                                    :src="app.caminho_logomarca" 
                                    :alt="app.nome" 
                                />
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-8 col-md-10 hidden-sm hidden-xs">
                        <div class="main-menu float-right">
                            <nav>
                                <ul>
                                    <li class="active"><a href="#banner">Home</a></li>
                                    <li><a href="#sobre">Sobre</a></li>
                                    <li><a href="#funcionalidades">Funcionalidades</a></li>
                                    <li><a href="#planos">Planos</a></li>
                                    <li><a href="javascript:ativaChat();">Suporte</a></li>
                                    <li><a href="/cadastro">Cadastre-se</a></li>
                                </ul>
                            </nav>
                        </div>
                        <a href="/login" class="menu-btn button-default button-olive">Acessar o sistema</a>
                    </div>
                    <div class="col-sm-12 hidden-lg hidden-md">
                        <div 
                            class="mobile-menu"
                            :logo="app.caminho_logomarca"
                        >
                            <nav>
                                <ul>
                                    <li class="active"><a href="#banner">Home</a></li>
                                    <li><a href="#sobre">Sobre</a></li>
                                    <li><a href="#funcionalidades">Funcionalidades</a></li>
                                    <li><a href="#planos">Planos</a></li>
                                    <li><a href="javascript:ativaChat();">Suporte</a></li>
                                    <li><a href="/cadastro">Cadastre-se</a></li>
                                    <li><a href="/login">Acessar o sistema</a></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
export default {
    props: ['app'],
}
</script>